import React from "react";
import { Shipment } from "../../types";
import { useTranslation } from "react-i18next";
import { FileCheck } from "lucide-react";

interface WaybillSectionProps {
  shipment?: Shipment;
  readonly: boolean;
  isWayBillCreated: boolean;
  setIsWayBillCreated: React.Dispatch<React.SetStateAction<boolean>>;
  WayBillLoading: boolean;
  dispatch: any;
  createWayBill: any;
}

export const WaybillSection: React.FC<WaybillSectionProps> = ({ shipment }) => {
  const { t } = useTranslation("shipments");
  if (!shipment || shipment?.waybill?.status !== "submitted") return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-md px-4 py-3">
      <div className="flex items-center gap-2 mb-1.5">
        <FileCheck className="h-4 w-4 text-blue-700" />
        <h4 className="text-[13px] font-semibold text-blue-900 uppercase tracking-wide">
          {t("waybill.title")}
        </h4>
      </div>
      <dl className="text-[12px] text-blue-800 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-0.5">
        <div className="flex gap-1">
          <dt className="text-blue-700">{t("waybill.status")}</dt>
          <dd className="font-medium">{shipment?.waybill?.status}</dd>
        </div>
        <div className="flex gap-1">
          <dt className="text-blue-700">{t("waybill.datasetId")}</dt>
          <dd className="font-medium">{shipment?.waybill?.datasetId || "N/A"}</dd>
        </div>
        <div className="flex gap-1">
          <dt className="text-blue-700">{t("waybill.submissionTime")}</dt>
          <dd className="font-medium">
            {shipment?.waybill?.submissionTime?.split("T")[0] || "N/A"}
          </dd>
        </div>
        <div className="sm:col-span-2 text-blue-700">
          {t("waybill.compliance")}
        </div>
      </dl>
    </div>
  );
};
